import { ButtonLink } from "design-system/atoms/Button"

import { Outlet } from "@tanstack/react-router"
import { BadgePingText } from "design-system/molecules/BadgePingText"
import { Card, CardDescription, CardHeader, CardTitle } from "design-system/molecules/Card"
import { Section } from "design-system/molecules/Section"
import { Pencil } from "lucide-react"
import { useZendeskIntegrationQuery } from "modules/settings/hooks/zendesk/useZendeskIntegrationQuery"
import { Loading } from "modules/shared/components/Loading"
import { useTranslation } from "react-i18next"
import { TestTicket } from "./components/TestTicket"

export const ZendeskIntegration = () => {
  const { t } = useTranslation()
  const { data, isPending } = useZendeskIntegrationQuery()

  if (isPending) {
    return <Loading />
  }

  const hasConfiguration = !!data
  const disabledReason = t("settings.integrations.disabledRequiresConfiguration")

  return (
    <div className="flex flex-col gap-8">
      <Card>
        <CardHeader className="flex flex-row gap-4 p-4">
          <div className="grow flex flex-col gap-1">
            <CardTitle>{t("settings.integrations.zendesk.integrationCard.title")}</CardTitle>
            <CardDescription>
              {hasConfiguration
                ? t("settings.integrations.zendesk.integrationCard.descriptionDone")
                : t("settings.integrations.zendesk.integrationCard.descriptionPending")}
            </CardDescription>
          </div>
          <div className="flex items-center">
            {hasConfiguration ? (
              <div className="flex gap-2">
                <BadgePingText
                  color={"success"}
                  text={t("settings.integrations.zendesk.integrationCard.connected")}
                />
                <ButtonLink
                  variant={"ghost"}
                  size="icon"
                  to="/settings/integrations/zendesk/connect"
                >
                  <Pencil />
                </ButtonLink>
              </div>
            ) : (
              <ButtonLink to={"/settings/integrations/zendesk/connect"}>
                {t("settings.integrations.zendesk.integrationCard.configButton")}
              </ButtonLink>
            )}
          </div>
        </CardHeader>
      </Card>
      <Section title={t("settings.integrations.zendesk.tools")}>
        <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-4">
          <TestTicket isDisabled={!hasConfiguration} disabledReason={disabledReason} />
        </div>
      </Section>
      <Outlet />
    </div>
  )
}
